import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import { postPythonApiAsyn, postApiLoginAsyn } from "../../Services/PostAPI";
import "./index.css";

const cookies = new Cookies();

const ResetPassword = ({ location }) => {
  // If a token is present this is the forgot-password email flow, not change-password
  const hashQuery = window.location.hash.includes("?")
    ? window.location.hash.substring(window.location.hash.indexOf("?"))
    : "";
  const resetToken =
    new URLSearchParams(location?.search).get("token") ||
    new URLSearchParams(hashQuery).get("token") ||
    "";

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");

  // ── Token-based reset (from forgot-password email) ──────────────────────────
  const handleTokenReset = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) { setIsError(true); setError("Passwords do not match."); return; }
    if (newPassword.length < 8) { setIsError(true); setError("Password must be at least 8 characters."); return; }
    setIsLoading(true); setIsError(false); setError("");
    try {
      const res = await postApiLoginAsyn("reset-password", { token: resetToken, password: newPassword, confirmPassword });
      if (res.status === 200) {
        setIsSuccess(true);
      } else {
        const body = await res.json().catch(() => ({}));
        setIsError(true);
        setError(body?.detail || body?.message || "Failed to reset password. The link may have expired.");
      }
    } catch { setIsError(true); setError("An error occurred. Please try again."); }
    finally { setIsLoading(false); }
  };

  // ── Logged-in change-password ────────────────────────────────────────────────
  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) { setIsError(true); setError("New passwords do not match."); return; }
    if (newPassword.length < 6) { setIsError(true); setError("Password must be at least 6 characters."); return; }
    setIsLoading(true); setIsError(false); setError("");
    try {
      const authToken = cookies.get("authorization");
      const res = await postPythonApiAsyn("change-password", { currentPassword, newPassword }, authToken);
      if (res && (res.status === 200 || res.message)) {
        setIsSuccess(true);
        setCurrentPassword(""); setNewPassword(""); setConfirmPassword("");
      } else {
        setIsError(true);
        setError(res?.message || res?.detail || "Failed to change password. Please check your current password.");
      }
    } catch { setIsError(true); setError("An error occurred. Please try again."); }
    finally { setIsLoading(false); }
  };

  if (resetToken) {
    return (
      <div className="ff-reset-container">
        <div className="ff-reset-box">
          <h3 className="ff-reset-title">Reset Password</h3>
          {isSuccess ? (
            <><div className="alert alert-success">Password updated successfully!</div><Link to="/">Back to Login</Link></>
          ) : (
            <form className="ff-reset-form" onSubmit={handleTokenReset}>
              <input type="password" placeholder="New password" className="form-control" required value={newPassword} onChange={(e) => setNewPassword(e.target.value)} disabled={isLoading} />
              <input type="password" placeholder="Confirm new password" className="form-control" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} disabled={isLoading} />
              <Button disabled={isLoading} type="submit" variant="primary">{isLoading ? "Updating..." : "Reset Password"}</Button>
              {isError && <div className="alert alert-danger mt-3">{error}</div>}
            </form>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="ff-reset-container">
      <div className="ff-reset-box">
        <h3 className="ff-reset-title">Change Password</h3>
        <form className="ff-reset-form" onSubmit={handleChangePassword}>
          <input type="password" placeholder="Current password" className="form-control" required value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} disabled={isLoading} />
          <input type="password" placeholder="New password" className="form-control" required value={newPassword} onChange={(e) => setNewPassword(e.target.value)} disabled={isLoading} />
          <input type="password" placeholder="Confirm new password" className="form-control" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} disabled={isLoading} />
          <Button disabled={isLoading} type="submit" variant="primary">{isLoading ? "Updating..." : "Update Password"}</Button>
        </form>
        {isSuccess && <div className="alert alert-success mt-3">Password updated successfully!</div>}
        {isError && <div className="alert alert-danger mt-3">{error}</div>}
      </div>
    </div>
  );
};

export default ResetPassword;
